import React, { useState, useEffect, Fragment } from 'react';
import { GlobalStyle, BoxIn, Goals, Text, BoxOut} from './style';
import Axios from 'axios';

function Board (){
    const [data, setData] = useState(
        [{from: 'Blank', to: 'blank', subject: 'blank', date:'', text:'blank'}]
    )
    const [open, setOpen] = useState()

    useEffect(() => {
        Axios.get('http://192.168.50.57:3030/').then(response =>{
            setData(response.data)
        })
    },[])

    function clickHandler (key) {
        setOpen(key)
    }
return(
    <div style={{width: '100%'}}>
    
    { data.map((item,key) =>
    
    <Fragment>
    
    {
   
    key === open ?
    <BoxIn>
        {console.log(key)}
        <Text>From: {item.fro}</Text>
        <Text>To: {item.too}</Text>
        <Text>Subject: {item.subject}</Text>
        <Text>Date: {item.date}</Text>
        <Text>{item.text}</Text>
    </BoxIn>
    :
    <BoxOut onClick={()=> clickHandler(key)}>
        <Text key={key}>From: {item.fro}</Text>
        <Text>{item.date} - {item.subject}</Text>
    </BoxOut>
    }
    </Fragment>
    
    )}

    </div>
)
}

export default Board;
